import React, { useState, useEffect } from "react";
import { Container } from "./styles";
import Footer from "../../components/sections/Footer";
import background from "../../assets/images/background.png";
import logo1 from "../../assets/images/logo.webp";
import logo2 from "../../assets/images/AboutImg.webp";
import cardBg from "../../assets/images/HomeBg.webp";
import backArrow from "../../assets/images/back-arrow-svgrepo-com.svg";
import TradingViewWidget from "../../components/tradingView/TradingViewWidget";
import TradingViewTickerTape from "../../components/tradingView/TradingViewTickerTape";
import SwapCoin from "../../components/SwapCoin";
import FarmItemX from "../../components/FarmItemX";
import { useWallet } from "../../hooks/useWallet";

const Staking = () => {
  const [page, setPage] = useState("main");
  const [stkAmount, setStkAmount] = useState(null);
  const [stkReward, setStkReward] = useState(0.45);
  const [stkCoinPrice, setStkCoinPrice] = useState(0.0);
  const { currentWallet, setCurrentWallet, connectMetaMask } = useWallet();
  const atualDate = new Date();
  const handleStaking = () => {
    setPage("stk");
  };
  const handleReturnToMain = () => {
    setPage("main");
  };
  return (
    <Container>
      {/* <img src={background} alt="" className="background-trading" /> */}
      {/* <h4>Staking</h4> */}
      {page == "main" && (
        <>
          <a
            href="#"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <div className="coin-box">
              <div className="subflex">
                <p>$GROK Presale </p>
                <span style={{ color: "rgb(88,236,59)", padding: "0 5px" }}>
                  (${stkCoinPrice})
                </span>
              </div>
              <div>
                <span>{"BUY >"}</span>
              </div>
            </div>
          </a>
          <div className="staking-card">
            <div className="staking-innercard">
              {/* <img src={cardBg} alt="" className="dc-background-img" /> */}
              <img className="stk-absolute__logo1" src={logo1} alt="" />
              <img className="stk-absolute__logo2" src={logo2} alt="" />
              <h4>Total Staked</h4>
              <span className="stk-price">0.0000 $GROK</span>
              <p className="stk-price-sub">Your Stake Cap 0 $GROK</p>
              <div className="stk-btn">
                <button
                  className="stk-income-btn1"
                  onClick={() => handleStaking()}
                >
                  Stake
                </button>
                <button className="stk-income-btn2">Details</button>
              </div>
            </div>
            <div className="stk-rewards ">
              <div className="stk-rewards__card first-card dc-invert">
                <small>Daily Rewards</small>
                <span>0.000</span>
              </div>
              <div className="stk-rewards__card dc-invert">
                <small>Daily Rewards</small>
                <span>0.000</span>
              </div>
            </div>
          </div>
          <div className="staking-card">
            <h5 className="stk-card2-title1 dc-invert">REFER & EARN</h5>
            <h5 className="stk-card2-title2 dc-invert">
              10-levels of commission
            </h5>
            <p className="stk-card2-title dc-invert">Your Referral link</p>
            <div className="stk-invite-box">
              <p>Link</p>
              <button>Copy</button>
            </div>
            <small className="stk-card2-footer dc-invert">
              Commission: <span> 0 </span> $GROK
            </small>
          </div>
          <table className="staking-list">
            <thead>
              <tr>
                <th>Refferals</th>
                <th>Buy Presale</th>
                <th>Commission</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />
        </>
      )}
      {page == "stk" && (
        <>
          <div className="pg-stk">
            <button
              className="pg-back-btn dc-invert"
              onClick={() => handleReturnToMain()}
            >
              <img src={backArrow} alt="" /> <p>Back</p>
            </button>
            <h2 className="pg-stk__title dc-invert">Staking to earn</h2>
            <h3 className="pg-stk__subtitle dc-invert">Daily Reward 3%</h3>
            <div className="staking-card stk-balance flex space-between">
              <div className="flex flex-column">
                <small>Available Balance</small>
                <span>0.000 $GROK</span>
              </div>
              <div>
                <a
                  href="#"
                  target="_blank"
                >
                  <button>Buy $GROK</button>
                </a>
              </div>
            </div>
            <div
              className="staking-card stk-now padding-20"
              style={{ backgroundColor: "black" }}
            >
              <p className="title ">Enter the staking amount:</p>
              <input
                className="stk-amount-input"
                type="number"
                placeholder="Staking Amount"
                value={stkAmount}
                onChange={(e) => setStkAmount(e.target.value)}
              />
              <div className="stk-divider"></div>
              <small className="stk-amount-sub flex">
                Stake Amount <span>0</span>/ 0 $GROK
              </small>
              <small className="title2">Estimated to Get</small>
              <div className="flex space-between gap">
                <div className="stk-card-reward2">
                  <p className="stk-card-reward2__title">Total Rewards</p>
                  <span className="stk-card-reward2__value">
                    {(stkAmount * stkReward).toFixed(3)} $GROK
                  </span>
                  <span className="stk-card-reward2__sub-value">
                    ≈$
                    {(stkAmount * stkReward * stkCoinPrice).toLocaleString(
                      "en-US"
                    )}{" "}
                    USDT
                  </span>
                  <small className="stk-card-reward2__info">
                    Daily rewards will be sent to your account at 24:00 (GMT+8).
                  </small>
                </div>
                <div className="stk-card-reward2">
                  <p className="stk-card-reward2__title">Stake Term</p>
                  <span className="stk-card-reward2__value">15 Days</span>
                  <span className="stk-card-reward2__sub-value">
                    Unstake & return
                  </span>
                  <small className="stk-card-reward2__info">
                    When the stake expires, it will be unstaked to your
                    available balance.
                  </small>
                </div>
              </div>
              <p className="stk-date">
                {/* After staking. you will start generating income at 2023-07-18
                24:00 (GMT+8). */}
              </p>
              <button onClick={connectMetaMask} className="stk-btn-action">
                Stake Now
              </button>
            </div>
          </div>
        </>
      )}
      <Footer />
    </Container>
  );
};

export default Staking;
